import request from '@/utils/request'
import JSONBig from 'json-bigint'

// 用 storeAsString 解析后端的雪花 ID（Long），避免 JS Number 精度丢失
const JSONBigString = JSONBig({ storeAsString: true })
const bigNumberTransform = [
  function (data) {
    if (typeof data !== 'string' || !data) return data
    try {
      return JSONBigString.parse(data)
    } catch (e) {
      return data
    }
  }
]

// 提交校园大使报名（id 也走大数解析，避免返回的报名 ID 被截断）
export function applyCampusAmbassador (data) {
  return request({
    url: '/v1/campusAmbassador/apply',
    method: 'post',
    data,
    transformResponse: bigNumberTransform
  })
}

// 查询我的报名信息
export function getMyAmbassadorApplication () {
  return request({
    url: '/v1/campusAmbassador/myApplication',
    method: 'get',
    transformResponse: bigNumberTransform
  })
}

// 取消报名
export function cancelCampusAmbassador (id) {
  return request({
    url: '/v1/campusAmbassador/cancel',
    method: 'post',
    params: { id }
  })
}
